<template>
  <b-form>
    <hr class="mt-0 mb-4" />
    <div>
      <b-row>
        <base-button
          type="default"
          block
          class="mb-3"
          @click="editarCatequista"
        >
          Crear nuevo Catequista
        </base-button>
        <formulario-Catequistas
          @guardaCatequista="guardaCatequista"
          :datosCatequista="catequista"
          :cursosSubgrupos="cursosSubgrupos"
        />
      </b-row>
      <b-row>
        <b-col>
          <tabla-catequistas
            :data="catequistas"
            @editarCatequista="editarCatequista"
            @eliminarCatequista="eliminarCatequista"
          />
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>
<script>
import axios from "@/directives/axios.js";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import tablaCatequistas from "@/components/Tables/TablaCatequistas.vue";
import formularioCatequistas from "@/components/Formularios/FormCatequista.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    VueBootstrapTypeahead,
    tablaCatequistas,
    formularioCatequistas,
  },
  props: {},
  data() {
    return {
      cursosSubgrupos: [],
      dataGroup: [],
      idSubgrupo: undefined,
      datosCurso: undefined,
      catequista: {
        nombre: "",
        apellido1: "",
        apellido2: "",
        fecha_nacimiento: "",
        correoElectronico: "",
        direccion: "",
        telefono: "",
        profesion: "",
        notas: "",
        id_subgrupo: "",
      },
      tipoFormulario: 1,
      esVisible: false,
    };
  },
  watch: {
    tipoFormulario: function () {},
  },
  computed: {
    catequistas() {
      if (this.$store.getters.getTodosCatequistasSimple != undefined) {
        loader.close();
        return this.$store.getters.getTodosCatequistasSimple;
      } else {
        loader.open();
        this.$store.dispatch("cargaCatequistasSimple");
        return [];
      }
    },
  },
  methods: {
    CargacursosSubgrupos() {
      loader.open();
      this.cursosSubgrupos = [];
      axios({
        method: "get",
        url: `/gestionCatequesis/todosCursosSubgrupos`,
        withCredentials: true,
      })
        .then((value) => {
          if (Array.isArray(value.data)) {
            value.data.forEach((element) => {
              var padre = element.nombre;
              if (Array.isArray(element.subgrupo)) {
                element.subgrupo.forEach((element2) => {
                  this.cursosSubgrupos.push({
                    value: element2.id,
                    text: padre + " - " + element2.nombre_subgrupo,
                  });
                });
              }
            });
          }
          loader.close();
        })
        .catch(() => {
          loader.close();
        });
    },
    eliminarCatequista(id) {
      loader.open();
      this.catequista = this.catequistas.find((element) => element.id == id);

      axios({
        method: "DELETE",
        url: `/gestionCatequesis/eliminarCatequista`,
        withCredentials: true,
        data: this.catequista,
      })
        .then((data) => {
          this.$store.dispatch("cargaCatequistasSimple", data);
          loader.close();
          swal.fire({
            title: `Datos Eliminados Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch(() => {
          loader.close();
        });
    },
    editarCatequista(datos) {
      this.catequista = null;
      if (datos) {
        this.catequista = this.catequistas.find(
          (element) => element.id == datos
        );
      }
      this.$nextTick(() => {
        this.$bvModal.show("modal-catequista");
      });
    },
    guardaCatequista(value) {
      loader.open();
      axios({
        method: "POST",
        url: `/gestionCatequesis/guardaCatequista`,
        withCredentials: true,
        data: value,
      })
        .then((data) => {
          this.$store.dispatch("cargaCatequistasSimple", data);
          loader.close();
          swal
            .fire({
              title: `Datos Actualizados`,
              text: "Datos actualizados correctamente",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then(() => {
              this.$bvModal.hide("modal-catequista");
            });
        })
        .catch(() => {
          loader.close();
          swal
            .fire({
              title: `ERROR`,
              text: "Ocurrio un erro inesperado, intentelo mas tarde",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-warning",
              icon: "warning",
            })
            .then(() => {
              this.$bvModal.hide("modal-grupo");
            });
        });
    },
    getData() {
      loader.open();
      axios({
        method: "GET",
        url: `/gestionCatequesis/todosCatequistas`,
        withCredentials: true,
      })
        .then((data) => {
          this.$store.dispatch("cargaCatequistasSimple", data);
          loader.close();
        })
        .catch(() => {
          loader.close();
        });
    },
  },
  mounted() {
    this.getData();
    this.CargacursosSubgrupos();
  },
};
</script>
<style></style>
